/* Boots Beauty: mobile scroller progress dots (vanilla) */
(function(){
  function init(root){
    root.querySelectorAll('[data-bb-scroller]').forEach(function(sc){
      if(sc.dataset.miaInit) return; sc.dataset.miaInit='1';
      var dots=sc.parentElement.querySelector('.bb-dots'); if(!dots) return;
      function build(){
        var cards=[].filter.call(sc.children,function(c){return c.offsetParent!==null});
        var pages=Math.max(1,Math.ceil(sc.scrollWidth/Math.max(1,sc.clientWidth)-0.05));
        dots.innerHTML=''; if(pages<2){dots.style.display='none';return;} dots.style.display='';
        for(var i=0;i<pages;i++){dots.appendChild(document.createElement('span'));}
        update();
      }
      function update(){
        var n=dots.children.length; if(!n) return;
        var max=sc.scrollWidth-sc.clientWidth; var idx=max>0?Math.round(sc.scrollLeft/max*(n-1)):0;
        [].forEach.call(dots.children,function(d,i){d.classList.toggle('is-on',i===idx)});
      }
      sc.addEventListener('scroll',function(){window.requestAnimationFrame(update)},{passive:true});
      window.addEventListener('resize',build); build();
    });
  }
  if(document.readyState!=='loading') init(document); else document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

/* ===== Boots Beauty cart: AJAX add from Boots Beauty cards (opens the drawer) ===== */
(function(){
  function addLines(variantId, qty){
    var A=window.Shopify&&Shopify.actions;
    if(A&&A.updateCart){
      return A.updateCart({lines:[{merchandiseId:String(variantId),quantity:qty||1}]}).then(function(res){
        if(res&&res.userErrors&&res.userErrors.length) throw new Error(res.userErrors[0].message||'Could not add to basket');
        var d=document.querySelector('theme-drawer#cart-drawer');
        if(d&&d.open&&!d.isOpen) d.open();
        return res;
      });
    }
    return Promise.reject(new Error('no-actions'));
  }
  function busy(btn,on){ if(!btn) return; btn.setAttribute('aria-busy',on?'true':'false'); btn.disabled=!!on; }
  function flash(btn,msg){ if(!btn) return; var t=btn.textContent; btn.textContent=msg; setTimeout(function(){btn.textContent=t;},2200); }
  // Boots Beauty product cards (homepage rows, bb-product-card snippet): open the drawer instead of navigating to /cart
  document.addEventListener('submit',function(e){
    var f=e.target; if(!(f instanceof HTMLFormElement)||!f.closest('.bb-card')) return;
    var id=f.querySelector('input[name="id"]'); if(!id||!(window.Shopify&&Shopify.actions)) return;
    e.preventDefault(); var btn=f.querySelector('button[type="submit"]'); busy(btn,true);
    addLines(id.value,parseInt((f.querySelector('input[name="quantity"]')||{}).value||'1',10)).then(function(){busy(btn,false);})
      .catch(function(err){busy(btn,false); if(err&&err.message==='no-actions'){f.submit();} else {flash(btn,(err&&err.message)||'Try again');}});
  });
})();
